/**
 * Public metadata for seed test accounts (no credentials).
 * Labels use the role name so quick-login buttons are scannable.
 * @see packages/db/src/prisma/seeds/users.ts
 */
export const QUICK_LOGIN_TEST_ACCOUNTS = [
  {
    email: "test@watt.co.uk",
    label: "Lead Generator"
  },
  {
    email: "test2@watt.co.uk",
    label: "Sales Agent"
  },
  {
    email: "test3@watt.co.uk",
    label: "Admin"
  },
  {
    email: "test4@watt.co.uk",
    label: "Compliance"
  },
  {
    email: "test5@watt.co.uk",
    label: "Manager"
  },
  {
    email: "test6@watt.co.uk",
    label: "Customer Service"
  },
  {
    email: "test7@watt.co.uk",
    label: "Finance"
  },
  {
    email: "test8@watt.co.uk",
    label: "Director"
  },
  {
    email: "test9@watt.co.uk",
    label: "Developer"
  }
] as const;

export type QuickLoginTestEmail =
  (typeof QUICK_LOGIN_TEST_ACCOUNTS)[number]["email"];

export type QuickLoginTestAccount = (typeof QUICK_LOGIN_TEST_ACCOUNTS)[number];
